import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";

import { Equipment } from "domain/entities/equipment";
import Spinner from "presentation/components/Shared/Spinner";

interface EquipmentMovementsTabProps {
  selectedEquipment: Equipment;
  isBaseDataComplete: boolean;
  loadingMovements: boolean;
  movements: any[];
  isVehicle?: boolean;
  tabContentStyle: React.CSSProperties;
  isAdminOrPatrimonio?: boolean;
  onOpenNewMovement: () => void;
  onOpenGallery: (photoKeys: string[], movementId: string) => void;
}

const EquipmentMovementsTab: React.FC<EquipmentMovementsTabProps> = ({
  selectedEquipment,
  isBaseDataComplete,
  loadingMovements,
  movements,
  isVehicle = false,
  tabContentStyle,
  isAdminOrPatrimonio = false,
  onOpenNewMovement,
  onOpenGallery,
}) => {
  return (
    <div style={tabContentStyle}>
      <div className="flex justify-content-between align-items-center mb-3">
        <h3 className="m-0">Registo de Movimentações</h3>
        {isAdminOrPatrimonio && (
          <Button
            label="Novo Movimento"
            icon="pi pi-plus"
            onClick={onOpenNewMovement}
            disabled={!selectedEquipment.id && !isBaseDataComplete}
          />
        )}
      </div>

      {!selectedEquipment.id && (
        <div className="text-gray-600 py-3">
          <p className="m-0">
            Na criação, depois de preencher os campos obrigatórios da tab Base,
            já pode registar o movimento inicial (Entrega / Alocação).
          </p>
          {selectedEquipment.employeeId && (
            <p className="mt-2 mb-0 font-semibold text-green-600">
              Movimento inicial configurado e pronto para guardar.
            </p>
          )}
        </div>
      )}

      {selectedEquipment.id &&
        (loadingMovements ? (
          <Spinner />
        ) : (
          <DataTable
            value={movements}
            paginator
            rows={5}
            className="mt-2 text-sm"
          >
            <Column
              field="type"
              header="Tipo"
              body={(row) => {
                const typesMap: Record<string, string> = {
                  STOCK_ENTRY: "Entrada em Stock",
                  DELIVERY: "Atribuir a Colaborador",
                  ABATE: "Abate de Equipamento",
                };

                if (row.type === "RETURN") {
                  return (
                    <strong>
                      {row.destinationState === "IN_MAINTENANCE"
                        ? "Envio a manutenção"
                        : "Devolução de Equipamento"}
                    </strong>
                  );
                }

                return <strong>{typesMap[row.type] || row.type}</strong>;
              }}
            />
            <Column
              field="employeeName"
              header="Colaborador"
              body={(row) => row.employeeName || row.employee?.name || "-"}
            />
            <Column
              field="actualDate"
              header="Data"
              body={(row) =>
                new Date(row.actualDate).toLocaleDateString("pt-PT")
              }
            />
            {isVehicle && (
              <Column
                field="odometerKm"
                header="Quilometragem (km)"
                body={(row) =>
                  row.odometerKm === null || row.odometerKm === undefined
                    ? "-"
                    : row.odometerKm
                }
              />
            )}
            <Column field="justification" header="Justificação / Notas" />
            <Column
              header="Fotos"
              body={(row) => {
                if (!row.photos) {
                  return "-";
                }

                try {
                  const photoList = JSON.parse(row.photos);

                  if (Array.isArray(photoList) && photoList.length > 0) {
                    return (
                      <Button
                        icon="pi pi-images"
                        label={`Ver Galeria (${photoList.length})`}
                        className="p-button-text p-button-sm font-semibold"
                        onClick={() => onOpenGallery(photoList, row.id)}
                      />
                    );
                  }
                } catch {}

                return "-";
              }}
            />
          </DataTable>
        ))}
    </div>
  );
};

export default EquipmentMovementsTab;
